export default "__VITE_ASSET__DUDdkUZj__"